import React from 'react';
import { SearchResult } from '../SearchResult/SearchResult';

export class SearchResultList extends React.PureComponent {
    render() {
        let searchResultNodes = (this.props.searchResult || []).map(sub => {
            return (
                <SearchResult key={sub.id} id={sub.id} title={sub.title}
                              description={sub.description} downloadUrl={sub.downloadUrl} />
            )
        });

        return (
            <div className="searchResultList">
                <div className="col-md-12">
                    <ul>
                        {searchResultNodes}
                    </ul>
                </div>
            </div>
        );
    }
};


// WEBPACK FOOTER //
// ../components/SearchResultList/SearchResultList.jsx